import React from "react";
import {FormattedMessage} from 'react-intl';
import {ApiResponse} from "@models/axios";

export const enum AliasType {
    "PERSON" = "person",
    "ROLE" = "role"
}

export const AliasTypeOptions = [{
    value: AliasType.PERSON,
    label: <FormattedMessage id="app.person" defaultMessage={`Person`}/>,
}, {
    value: AliasType.ROLE,
    label: <FormattedMessage id="app.role" defaultMessage={`Role`}/>,
}];


export interface Alias extends ApiResponse {
    "reference_id": "string",
    "type": AliasType,
    "text": string,
    "id": string,
    "short_id": string,
    "created_at": any,
    "modified_at": any
}

export interface AliasState {
    readonly loading: boolean;
    readonly data: Alias[];
    readonly errors?: string;
    readonly count: number
}
